import http from "./http";

const common = {
    //存储token
    setToken:function (token) {
        this.setCookie("token", token);
    },
    //设置token
    getToken:function () {
        return this.getCookie("token");
    },
    setCookie:function(name,value) {
    document.cookie = name + "="+ escape (value) + "; domain=jinku.com; path=/";
    },

    getCookie:function(name) {
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg)) {
            return unescape(arr[2]);
        }else{
            return null;
        }
    },
    delCookie:function(name) {
        var exp     = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval    = this.getCookie(name);
        if(cval!=null) {
            document.cookie= name + "="+cval+";expires="+exp.toGMTString();
        }
    },
    getUrlParam: function(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    }
};

export default common;




// WEBPACK FOOTER //
// ./src/lib/common.js